import { Route, Routes } from 'react-router-dom';
import './App.css';
import SignUp from './pages/auth/SignUp';
import Coupon from './pages/Coupon';
import Coupon2 from './pages/Coupon2';
import Login from './pages/auth/Login';
import AdminInfo from './pages/admin/admins/AdminInfo';
import NotFound from './pages/NotFound';
import Unauthorized from './pages/auth/Unauthorized';
import Dashboard from './pages/Dashboard';
import Simulation from './pages/Simulation';
import AdminRoutes from './routes/AdminRoutes';
import UserRoutes from './routes/UserRoutes';
import SystemEnvVariables from './pages/admin/SystemEnvVariables';
import Notice from './pages/admin/Notice';
import User from './pages/admin/users/User';
import UserInfo from './pages/admin/users/UserInfo';
import AddUser from './pages/admin/users/AddUser';
import AddNotice from './pages/admin/AddNotice';
import UserDashboard from './pages/user/UserDashboard';
import Issue from './pages/admin/Issue';
import AddIssue from './pages/admin/AddIssue';
import UrinalysisManagement from './pages/admin/UrinalysisManagement';
import AddAdmin from './pages/admin/admins/AddAdmin';
import Admin from './pages/admin/admins/Admin';
import TreeViewDetail from './pages/tree/TreeViewDetail';
import React, { useEffect } from 'react';

function App() {
  useEffect(() => {
    // 배포된 클라이언트를 새 빌드로 강제 갱신하는 장치.
    // 개발 서버(npm start)에서는 돌리지 않는다 — .env 의 REACT_APP_VERSION 은
    // 기동 시점에 번들에 박히는데 public/version.json 은 파일을 그대로 서빙하므로,
    // 서버를 켜둔 채 빌드/배포로 버전을 다시 스탬핑하면 두 값이 어긋나
    // 10초마다 무한 새로고침에 빠진다. 개발 환경엔 이 기능이 필요 없다.
    if (process.env.NODE_ENV !== 'production') return;

    const currentVersion = process.env.REACT_APP_VERSION;

    const checkVersion = async () => {
      try {
        const res = await fetch('/version.json', { cache: 'no-store' });
        const data = await res.json();
        if (data.version !== currentVersion) {
          console.log(currentVersion, data.version, '🔄 새 버전 감지됨! 자동 새로고침');
          window.location.reload();
        }
      } catch (err) {
        console.error('버전 체크 실패', err);
      }
    };

    const interval = setInterval(checkVersion, 10000); // 10초 간격
    return () => clearInterval(interval);
  }, []);

  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/register" element={<SignUp />} />
      <Route path="/unauthorized" element={<Unauthorized />} />
      <Route element={<AdminRoutes />}>
        <Route path="/ad/dashboard" element={<Dashboard />} />
        <Route path="/ad/admin" element={<Admin />} />
        <Route path="/ad/adminInfo/:adminSeq" element={<AdminInfo />} />
        <Route path="/ad/addAdmin" element={<AddAdmin />} />
        <Route path="/ad/user" element={<User />} />
        <Route path="/ad/userInfo/:userSeq" element={<UserInfo />} />
        <Route path="/ad/addUser" element={<AddUser />} />
        <Route path="/ad/coupon" element={<Coupon />} />
        <Route path="/ad/coupon2" element={<Coupon2 />} />
        <Route path="/ad/simulation" element={<Simulation />} />
        <Route path="/ad/envvariables" element={<SystemEnvVariables />} />
        <Route path="/ad/uri/mnt" element={<UrinalysisManagement />} />
        <Route path="/ad/notice" element={<Notice />} />
        <Route path="/ad/addNotice" element={<AddNotice />} />
        <Route path="/ad/issue" element={<Issue />} />
        <Route path="/ad/addissue" element={<AddIssue />} />
        <Route path="/ad/treeViewDetail" element={<TreeViewDetail />} />
      </Route>
      <Route element={<UserRoutes />}>
        <Route path="/user/admin" element={<Admin />} />
        <Route path="/user/dashboard" element={<UserDashboard />} />
        <Route path="/user/user" element={<User />} />
        <Route path="/user/userInfo/:userSeq" element={<UserInfo />} />
        <Route path="/user/coupon" element={<Coupon />} />
        <Route path="/user/coupon2" element={<Coupon2 />} />
        <Route path="/user/treeViewDetail" element={<TreeViewDetail />} />
      </Route>
      {/* <Route element={<RequireAuth allowedRoles={[ROLES.Admin, ROLES.Distributor, ROLES.User]} />}>
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/coupon" element={<Coupon />} />
                <Route path="/user" element={<User />} />
                <Route path="/admin" element={<Admin />} />
                <Route path="/adminInfo/:adminSeq" element={<AdminInfo />} />
                <Route path="/addAdmin" element={<AddAdmin />} />
                <Route path="/userInfo/:userSeq" element={<UserInfo />} />
                <Route path="/addUser" element={<AddUser />} />
                <Route path="/simulation" element={<Simulation />} />
            </Route> */}
      {/* <Route element={<RequireAuth allowedRoles={[ROLES.User]} />}>
                // <Route path="/dashboard" element={<Dashboard />} />
                // <Route path="/coupon" element={<Coupon />} />
            </Route> */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default App;
